import { Link, useLocation } from 'react-router-dom'
import Protected from '../../Protected'

export const ProjectSupportComponents = (props) => {

  const location = useLocation();

  if (props.breadcrumbData === undefined) {
    return "NO CORRECT DATA"
  }

  const handleLink = (e, module, to) => {
    if(location.pathname.split('/').at(-1) === module) e.preventDefault();
  }
  const bc = props.breadcrumbData;
  const filter = props.filter ?? '';

  return (
    <>
      <ul className="nav nav-tabs" id="borderedTab">

        <Protected returnNull={true} permissions={['view_Overview']} >
          <Link className="nav-item" role="presentation" to={`/projectsdetails/${bc}/overview`}>
            <button className={"projectNav nav-link" + (props.data === 0 ? ' active' : '')} id="home-tab" data-bs-toggle="tab" data-bs-target="#bordered-home" type="button" role="tab" aria-controls="home" aria-selected="true"><i className="bi bi-graph-up"></i> Overview</button>
          </Link>
        </Protected>

        <Protected returnNull={true} permissions={['view_Breakdown']} >
          <Link className="nav-item" role="presentation" to={`/projectsdetails/${bc}/breakdown`}>
            <button className={"projectNav nav-link" + (props.data === 1 ? ' active' : '')} id="profile-tab" data-bs-toggle="tab" data-bs-target="#bordered-profile" type="button" role="tab" aria-controls="profile" aria-selected="false" tabIndex="-1"><i className="ri-list-unordered"></i> Breakdown</button>
          </Link>
        </Protected>

        <Protected returnNull={true} permissions={['view_ScriptBase']} >
          <Link className="nav-item" role="presentation" to={`/projectsdetails/${bc}/script${filter}`} onClick={(e) => handleLink(e, 'script', `/projectsdetails/${bc}/script${filter}`)}>
            <button className={"projectNav nav-link" + (props.data === 2 ? ' active' : '')} id="contact-tab" data-bs-toggle="tab" data-bs-target="#bordered-contact" type="button" role="tab" aria-controls="contact" aria-selected="false" tabIndex="-1"><i className="bx bx-grid"></i> Script Grid</button>
          </Link>
        </Protected>

        <Protected returnNull={true} permissions={['view_ExcelModule']} >
          <Link className="nav-item" role="presentation" to={`/projectsdetails/${bc}/excel`}>
            <button className={"projectNav nav-link" + (props.data === 3 ? ' active' : '')} id="contact-tab" data-bs-toggle="tab" data-bs-target="#bordered-contact" type="button" role="tab" aria-controls="contact" aria-selected="false" tabIndex="-1"><i className="bx bx-spreadsheet"></i> Script Excel style</button>
          </Link>
        </Protected>

        <Protected returnNull={true} permissions={['view_GantChart']} >
          <Link className="nav-item" role="presentation" to={`/projectsdetails/${bc}/gantt`}>
            <button className={"projectNav nav-link" + (props.data === 4 ? ' active' : '')} id="contact-tab" data-bs-toggle="tab" data-bs-target="#bordered-contact" type="button" role="tab" aria-controls="contact" aria-selected="false" tabIndex="-1"><i className="ri-map-pin-time-line"></i> Gantt</button>
          </Link>
        </Protected>
        {/*
        <Protected returnNull={true} permissions={['view_BreakDownBuilder']} >
          <Link className="nav-item" role="presentation" to={`/projectsdetails/${bc}/bdbuilder`}>
            <button className={"projectNav nav-link"  + (props.data === 5 ? ' active' : '')} id="contact-tab" data-bs-toggle="tab" data-bs-target="#bordered-contact" type="button" role="tab" aria-controls="contact" aria-selected="false" tabIndex="-1"><i className="ri-line-height"></i> Breakdown Builder</button>
          </Link>
        </Protected>
    */  }
        <Protected returnNull={true} permissions={['view_Trello']} >
          <Link className="nav-item" role="presentation" to={`/projectsdetails/${bc}/production`}>
            <button className={"projectNav nav-link" + (props.data === 6 ? ' active' : '')} id="contact-tab" data-bs-toggle="tab" data-bs-target="#bordered-contact" type="button" role="tab" aria-controls="contact" aria-selected="false" tabIndex="-1"><i className="ri-task-line"></i> Production</button>
          </Link>
        </Protected>
        <Protected returnNull={true} permissions={['ShareSession']} >
          <Link className="nav-item" role="presentation" to={`/projectsdetails/${bc}/sessions`}>
            <button className={"projectNav nav-link" + (props.data === 7 ? ' active' : '')} id="sessions-tab" data-bs-toggle="tab" data-bs-target="#bordered-sessions" type="button" role="tab" aria-controls="sessions" aria-selected="false" tabIndex="-1"><i className="bi bi-collection"></i> Recording Sessions</button>
          </Link>
        </Protected>
        <Protected returnNull={true} permissions={['actorsContracts']} >
          <Link className="nav-item" role="presentation" to={`/projectsdetails/${bc}/actors`}>
            <button className={"projectNav nav-link" + (props.data === 8 ? ' active' : '')} id="contact-tab" data-bs-toggle="tab" data-bs-target="#bordered-contact" type="button" role="tab" aria-controls="contact" aria-selected="false" tabIndex="-1"><i className="bi bi-person-fill"></i> AOR & Credits </button>
          </Link>
        </Protected>
        <Protected returnNull={true} permissions={['view_Media']} >
          <Link className="nav-item" role="presentation" to={`/projectsdetails/${bc}/inspector`}>
            <button className={"projectNav nav-link" + (props.data === 9 ? ' active' : '')} id="contact-tab" data-bs-toggle="tab" data-bs-target="#bordered-contact" type="button" role="tab" aria-controls="contact" aria-selected="false" tabIndex="-1"><i className="bi bi-soundwave"></i> Inspector</button>
          </Link>
        </Protected>
        <Protected returnNull={true} permissions={['manageAssets']} >
          <Link className="nav-item" role="presentation" to={`/projectsdetails/${bc}/explorer`}>
            <button className={"projectNav nav-link" + (props.data === 10 ? ' active' : '')} id="contact-tab" data-bs-toggle="tab" data-bs-target="#bordered-contact" type="button" role="tab" aria-controls="contact" aria-selected="false" tabIndex="-1"><i className="bi bi-folder"></i> Explorer</button>
          </Link>
        </Protected>

        <Protected returnNull={true} permissions={['deliveryDashboard']} >
          <Link className="nav-item" role="presentation" to={`/projectsdetails/${bc}/delivery`}>
            <button className={"projectNav nav-link" + (props.data === 11 ? ' active' : '')} id="contact-tab" data-bs-toggle="tab" data-bs-target="#bordered-contact" type="button" role="tab" aria-controls="contact" aria-selected="false" tabIndex="-1"><i className="bi bi-clipboard-check"></i>{'\u00A0Tracking\u00A0Matrix'}</button>
          </Link>
        </Protected>

      </ul>
    </>
  )
}



export const ProjectUpperBar_____ = (props) => {


  return (

    <div className="pagetitle">
      <h1>Information</h1>
      <nav>
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <Link to={"/"}>Home</Link>
          </li>
          <li className="breadcrumb-item">
            <Link to={"/projects"}>Projects</Link>
          </li>
          <li className="breadcrumb-item">
            <Link to={"/batches/6"}>Hearthstone</Link>
          </li>
          <li className="breadcrumb-item">
            <Link href="/scripts/13">HS_26</Link>
          </li>
          <li className="breadcrumb-item active">HS26_Ingame (esES)</li>
        </ol>
      </nav>
    </div>
  )
}

export const ProjectUpperBar = (props) => {

  if (props.breadcrumbData === undefined) {
    return "WOW"
  }

  let h1Title = "";
  if (props.nameModule !== undefined) {
    h1Title = props.nameModule
  }

  const bc = props.breadcrumbData;
  return (

    <div className="pagetitle">
      <h1>{h1Title}</h1>
      <nav>
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <Link to={"/"}>Home</Link>
          </li>
          <li className="breadcrumb-item">
            <Link to={"/projects"}>Projects</Link>
          </li>
          <li className="breadcrumb-item">
            {bc.project_name}
          </li>
          <li className="breadcrumb-item">
            {bc.batch_name}
          </li>
          <li className="breadcrumb-item active">{bc.script_name} ({bc.language_code})</li>
        </ol>
      </nav>
    </div>
  )
}


export const NewProjectUpperBar = (props) => {

  const projectNames = [];
  const projectBatch = [];
  const projectScript = [];
  const projectLanguage = [];

  if (props.breadcrumbData === undefined) {
    return "WOW"
  }

  props.breadcrumbData.forEach(function (el, idx) {
    projectNames[el.project_name] = el.project_name
    projectBatch[el.batch_name] = el.batch_name
    if (el.script_name) {
      projectScript[el.script_name] = el.script_name
    }
    if (el.language_code) {
      projectLanguage[el.language_code] = el.language_code
    }
  })

  //const bc = props.breadcrumbData[0];

  let h1Title = "Information";
  if (props.nameModule !== undefined) {
    h1Title = props.nameModule
  }

  // Only hide batches/scripts if explicitly requested (for AOR & Credits page)
  const hideBatches = props.hideBatches === true;

  return (

    <div className="pagetitle" style={props?.style}>
      <h1>{h1Title}</h1>
      <nav>
        <ol className="breadcrumb" style={{maxHeight: '6em', overflow: 'auto'}}>
          <li className="breadcrumb-item">
            <Link to={"/"}>Home</Link>
          </li>
          <li className="breadcrumb-item">
            <Link to={"/projects"}>Projects</Link>
          </li>
          <li className="breadcrumb-item">
            {Object.keys(projectNames).length > 1 ? <span className="multiple">{"[ " + Object.keys(projectNames).join(' - ') + " ]"}</span> : Object.keys(projectNames)}
          </li>

          {/* Only show batches/scripts if NOT hidden */}
          {!hideBatches && (
            <>
              <li className="breadcrumb-item">
                {Object.keys(projectBatch).length > 1 ? <span className="multiple">{"[ " + Object.keys(projectBatch).join(' - ') + " ]"}</span> : Object.keys(projectBatch)}
              </li>

              {Object.keys(projectScript).length > 0 &&
                <>
                  <li className="breadcrumb-item">
                    {Object.keys(projectScript).length > 1 ? <span className="multiple">{"[ " + Object.keys(projectScript).join(' - ') + " ]"}</span> : Object.keys(projectScript)}
                  </li>
                  <li className="breadcrumb-item active">{Object.keys(projectLanguage).length > 1 ? <span className="multiple">{"[ " + Object.keys(projectLanguage).join(' - ') + " ]"}</span> : Object.keys(projectLanguage)}</li>
                </>}
            </>
          )}
        </ol>
      </nav>
    </div>
  )
}
